<template>
  <div class="max-w-7xl mx-auto flex flex-col relative">
    <nav class="max-w-7xl px-5 md:fixed top-0 z-[98] w-screen backdrop-blur-md bg-[#121212] bg-opacity-80">
      <div class="container mx-auto flex flex-wrap items-center justify-between">
        <button @click="redirectToHome" class="flex" aria-label="Go to homepage">
          <span class="self-center text-lg text-[#ffdb70] font-semibold whitespace-nowrap fadein-bot hover:text-amber-100">@aristestpen</span>
        </button>
        <div class="flex items-center gap-4 md:order-2 fadein-bot">
          <a href="https://github.com/aristestpen" target="_blank" rel="noopener" aria-label="GitHub Profile">
            <img class="w-9 rounded-full" src="/img/icons/github-logo.png" alt="GitHub">
          </a>
          <button @click="mobileMenuOpen = !mobileMenuOpen" class="md:hidden text-white p-1" aria-label="Toggle menu">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path v-if="!mobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              <path v-else stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="hidden md:flex justify-between items-center w-full md:w-auto md:order-1">
          <ul class="flex-col md:flex-row flex md:space-x-8 mt-4 md:mt-0 md:text-sm md:font-medium">
            <li>
              <router-link to="/" class="fadein-bot nav-link" aria-current="page">Home</router-link>
            </li>
            <li>
              <router-link to="/about" class="fadein-bot fadein-1 nav-link">About</router-link>
            </li>
            <li>
              <router-link to="/portfolio" class="fadein-bot fadein-2 nav-link">Portfolio</router-link>
            </li>
          </ul>
        </div>
      </div>
      <!-- Mobile dropdown menu -->
      <transition name="slide-down">
        <div v-if="mobileMenuOpen" class="md:hidden pb-4">
          <ul class="flex flex-col space-y-2 mt-2">
            <li>
              <router-link to="/" @click="mobileMenuOpen = false" class="block px-3 py-2 rounded-lg text-gray-300 hover:bg-white/10 hover:text-white transition-colors">Home</router-link>
            </li>
            <li>
              <router-link to="/about" @click="mobileMenuOpen = false" class="block px-3 py-2 rounded-lg text-gray-300 hover:bg-white/10 hover:text-white transition-colors">About</router-link>
            </li>
            <li>
              <router-link to="/portfolio" @click="mobileMenuOpen = false" class="block px-3 py-2 rounded-lg text-gray-300 hover:bg-white/10 hover:text-white transition-colors">Portfolio</router-link>
            </li>
          </ul>
        </div>
      </transition>
    </nav>

    <div class="md:mt-[100px]">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </div>

  <footer class="block md:hidden fixed bottom-0 left-0 right-0 rounded-t-3xl border border-[#383838] bg-[#121212] bg-opacity-80 backdrop-blur-md backdrop-opacity-90 z-[99]" style="padding-bottom: env(safe-area-inset-bottom)">
    <nav class="flex justify-around py-4 text-xs">
      <router-link to="/" class="text-gray-300 hover:text-white" aria-label="Home">Home</router-link>
      <router-link to="/about" class="text-gray-300 hover:text-white" aria-label="About">About</router-link>
      <router-link to="/portfolio" class="text-gray-300 hover:text-white" aria-label="Portfolio">Portfolio</router-link>
    </nav>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      mobileMenuOpen: false,
    }
  },
  methods: {
    redirectToHome() {
      this.$router.push('/')
    }
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&display=swap');

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: hsl(240, 1%, 17%);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  background: #ffdb70;
  border-radius: 5px;
}

::-webkit-scrollbar-button { width: 20px; }

body {
  font-family: 'Outfit', sans-serif;
  background: #0a0a0a;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #e0e0e0;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}

/* Gradient mesh background */
body::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background:
    radial-gradient(ellipse 600px 600px at 10% 20%, rgba(255, 219, 112, 0.06) 0%, transparent 70%),
    radial-gradient(ellipse 500px 500px at 80% 50%, rgba(139, 92, 246, 0.04) 0%, transparent 70%),
    radial-gradient(ellipse 400px 400px at 50% 80%, rgba(255, 219, 112, 0.03) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
}

nav {
  padding: 30px;
}

.nav-link {
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
  border-bottom: 1px solid transparent;
  display: block;
  padding: 0.5rem 0.75rem;
  transition: color 0.3s;
}

.nav-link:hover {
  color: rgba(255, 255, 255, 0.8);
}

nav a.router-link-exact-active {
  display: inline-flex;
  flex-direction: column;
  color: white;
  transition: color 0.3s;
}

nav a.router-link-exact-active::after {
  display: inline-block;
  content: "";
  margin-top: 0.08em;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background: linear-gradient(90deg, #ffdb70, #ff9f43);
}

nav a.router-link-exact-active:hover {
  color: white;
}

/* ===== Utility Classes ===== */

/* Gradient text */
.gradient-text {
  background: linear-gradient(135deg, #ffdb70, #ff9f43, #ffdb70);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.gradient-text-white {
  background: linear-gradient(135deg, #ffffff, #ffdb70);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Glassmorphism */
.glass {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.glass-hover:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 219, 112, 0.2);
  box-shadow: 0 0 20px rgba(255, 219, 112, 0.08);
}

/* Glow effects */
.glow-amber {
  box-shadow: 0 0 30px rgba(255, 219, 112, 0.15);
}

.glow-amber-hover:hover {
  box-shadow: 0 0 40px rgba(255, 219, 112, 0.2);
}

@keyframes pulseGlow {
  0%, 100% { box-shadow: 0 0 20px rgba(255, 219, 112, 0.3); }
  50% { box-shadow: 0 0 40px rgba(255, 219, 112, 0.5), 0 0 60px rgba(255, 219, 112, 0.2); }
}

.glow-pulse {
  animation: pulseGlow 3s ease-in-out infinite;
}

/* ===== Shared Animations ===== */
@keyframes fadeInLeft {
  from { opacity: 0; transform: translateX(-100%); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translate3d(0, 40px, 0); }
  to { opacity: 1; transform: translate3d(0, 0, 0); }
}

@keyframes fadeInRight {
  from { opacity: 0; transform: translateX(100%); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes fadeInBot {
  from { opacity: 0; transform: translate3d(0, -30px, 0); }
  to { opacity: 1; transform: translate3d(0, 0, 0); }
}

@keyframes fadeZoomIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}

.fadein-up {
  opacity: 0;
  animation: fadeInUp 0.6s ease-out forwards;
  animation-delay: 500ms;
}

.fade-in-from-left {
  opacity: 0;
  animation: fadeInLeft 0.5s ease-out forwards;
  animation-delay: 500ms;
}

.fadein-right {
  opacity: 0;
  animation: fadeInRight 0.5s ease-out forwards;
  animation-delay: 500ms;
}

.fadein-bot {
  opacity: 0;
  animation: fadeInBot 0.5s forwards;
}

.fadein-left {
  opacity: 0;
  animation: fadeInLeft 0.5s ease-out forwards;
}

.fade-zoom-in {
  animation: fadeZoomIn 0.8s ease-out;
}

.fadein-1 { animation-delay: 200ms; }
.fadein-2 { animation-delay: 400ms; }
.fadein-3 { animation-delay: 600ms; }
.fadeins-1 { animation-delay: 500ms; }
.fadeins-2 { animation-delay: 800ms; }
.fade-500 { animation-delay: 500ms; }

/* Page transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Mobile menu slide */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}
.slide-down-enter-from,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
